module.exports = __webpack_public_path__ + "static/media/VectorResendEmail.2a54403f.svg";